var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts"},[_c('div',{staticClass:"echarts_list",staticStyle:{"height":"400px"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }